import {
  EVENT_TYPE_LIST_TAGS,
  FETCH_EVENT_TYPES,
  FETCH_PROFILES,
  SCHEDULING_FETCH_EVENT_TYPES,
} from 'constants/event_types'

import { currentOrganizationSelector } from '../../selectors/current_organization'
import { filterEnabledMemberships } from './control_panel/sections/components/helpers'

const removeUuidsFromProfileEntities = (entities, uuidsToRemove) => {
  if (!entities) return

  uuidsToRemove.forEach((eventTypeUuid) => {
    Object.values(entities).forEach((entity) => {
      if (!entity) return

      if (entity.eventTypeIds) {
        entity.eventTypeIds = entity.eventTypeIds.filter((id) => id !== eventTypeUuid)
      }

      if (entity.event_types) {
        entity.event_types = entity.event_types.filter((eventType) => eventType.uuid !== eventTypeUuid)
      }
    })
  })
}

export const removeEventTypeFromListCachesData = ({ api, state, dispatch, uuid, uuids }) => {
  const uuidsToRemove = uuids ?? (uuid ? [uuid] : [])
  if (uuidsToRemove.length === 0) return

  api.util.selectInvalidatedBy(state, EVENT_TYPE_LIST_TAGS).forEach(({ endpointName, originalArgs }) => {
    switch (endpointName) {
      case FETCH_PROFILES:
      case 'schedulingFetchProfiles':
        dispatch(
          api.util.updateQueryData(endpointName, originalArgs, (draft) => {
            removeUuidsFromProfileEntities(draft?.results?.entities, uuidsToRemove)
          })
        )
        break
      case SCHEDULING_FETCH_EVENT_TYPES:
      case FETCH_EVENT_TYPES:
        dispatch(
          api.util.updateQueryData(endpointName, originalArgs, (draft) => {
            uuidsToRemove.forEach((eventTypeUuid) => {
              delete draft[eventTypeUuid]
            })
          })
        )
        break
      default:
        break
    }
  })
}

export const updateEventTypeListsCacheData = ({ api, state, dispatch, data }) => {
  api.util.selectInvalidatedBy(state, EVENT_TYPE_LIST_TAGS).forEach(({ endpointName, originalArgs }) => {
    switch (endpointName) {
      case FETCH_PROFILES:
        dispatch(
          api.util.updateQueryData(FETCH_PROFILES, originalArgs, (draft) => {
            const userEntity = data.owner_id && draft?.results?.entities?.[`${data.owner_type}::${data.owner_id}`]
            const orgEntity = draft?.results?.entities?.[`Organization::${currentOrganizationSelector(state).id}`]
            const entity = userEntity || orgEntity

            if (entity) {
              entity.event_types.forEach((eventType) => {
                if (eventType.uuid === data.uuid) {
                  Object.assign(eventType, { ...data, memberships: filterEnabledMemberships(data.memberships) })
                }
              })
            }
          })
        )
        break
      case SCHEDULING_FETCH_EVENT_TYPES:
        dispatch(
          api.util.updateQueryData(SCHEDULING_FETCH_EVENT_TYPES, originalArgs, (draft) => {
            draft[data.uuid] = { ...draft[data.uuid], ...data, memberships: filterEnabledMemberships(data.memberships) }
          })
        )
        break
      case FETCH_EVENT_TYPES:
        dispatch(
          api.util.updateQueryData(FETCH_EVENT_TYPES, originalArgs, (draft) => {
            draft[data.uuid] = { ...draft[data.uuid], ...data, memberships: filterEnabledMemberships(data.memberships) }
          })
        )
        break
      default:
        break
    }
  })
}

export const updateWorkflowsCacheData = ({ api, state, dispatch, data, workflowsExtractionEnabled }) => {
  const queryName = workflowsExtractionEnabled ? 'fetchWorkflowsForEventType' : 'fetchLegacyWorkflowsForEventType'

  api.util.selectInvalidatedBy(state, ['WORKFLOWS']).forEach(({ endpointName, originalArgs }) => {
    if (endpointName === queryName) {
      dispatch(api.util.updateQueryData(queryName, originalArgs, (draft) => {
        if (draft?.list) {
          draft.list = draft.list.filter((workflow) => workflow.uuid !== data.uuid)
        }
      }))
    }
  })
}
